import { create } from 'zustand';
import { CalendarViewState, CalendarViewType, TimeScale, TIME_SCALE_OPTIONS } from '../types/calendar.types';

interface CalendarViewStore extends CalendarViewState {
  // Actions
  setViewType: (type: CalendarViewType) => void;
  setDayViewDays: (days: number) => void;
  setTimeScale: (scale: TimeScale) => void;
  setCurrentDate: (date: Date) => void;
  selectDate: (date: Date | undefined) => void;
  goToToday: () => void;
  goToPrevious: () => void;
  goToNext: () => void;
}

export const useCalendarViewStore = create<CalendarViewStore>((set, get) => ({
  // Initial state
  viewType: 'week',
  dayViewDays: 1,
  currentDate: new Date(),
  selectedDate: undefined,
  timeScale: 60,

  // Actions
  setViewType: (type) => set({ viewType: type }),
  
  setDayViewDays: (days) => set({ dayViewDays: Math.max(1, Math.min(7, days)) }),
  
  setTimeScale: (scale) => set({ timeScale: scale }),
  
  setCurrentDate: (date) => set({ currentDate: date }),
  
  selectDate: (date) => set({ selectedDate: date }),
  
  goToToday: () => set({ currentDate: new Date() }),
  
  goToPrevious: () => {
    const { currentDate, viewType, dayViewDays } = get();
    const newDate = new Date(currentDate);
    
    switch (viewType) {
      case 'day':
        newDate.setDate(newDate.getDate() - dayViewDays);
        break;
      case 'week':
      case 'workweek':
        newDate.setDate(newDate.getDate() - 7);
        break;
      case 'month':
        newDate.setMonth(newDate.getMonth() - 1);
        break;
    }
    
    set({ currentDate: newDate });
  },
  
  goToNext: () => {
    const { currentDate, viewType, dayViewDays } = get();
    const newDate = new Date(currentDate);
    
    switch (viewType) {
      case 'day':
        newDate.setDate(newDate.getDate() + dayViewDays);
        break;
      case 'week':
      case 'workweek':
        newDate.setDate(newDate.getDate() + 7);
        break;
      case 'month':
        newDate.setMonth(newDate.getMonth() + 1);
        break;
    }
    
    set({ currentDate: newDate });
  },
}));
